const spbw = (...strs) => strs.filter(Boolean).join(' ');

export default spbw;
